<div class="main-content content-with-side-menu">
    <h1 class="page-header">
        <app-go-back></app-go-back> {{ "PurchaseEdit.title" | translate }}
    </h1>

    @if (cart) {
        <div class="purchase-details">
            @if (waitingForPaymentProcessorResponse) {
                <bcu-local-spinner
                    [size]="50"
                    [visible]="waitingForPaymentProcessorResponse"
                ></bcu-local-spinner>
                <div class="row size-16">
                    <div class="col text-center main-blue mt-5">
                        {{
                            "SellCamp.ValidatingPaymentProcessorPayment"
                                | translate
                        }}
                    </div>
                </div>
            } @else {
                <app-purchase-edit-info
                    [purchase]="cart.finalizedPurchase"
                ></app-purchase-edit-info>
                <div class="voffset-10">
                    @if (isEdit) {
                        <app-purchase-edit-sessions
                            [cart]="cart"
                            [weeks]="weeks"
                            [cartSummary]="cartSummary"
                        ></app-purchase-edit-sessions>
                    }
                    @if (isSummary) {
                        <app-purchase-edit-sessions-summary
                            [cartSummary]="cartSummary"
                        ></app-purchase-edit-sessions-summary>
                    }
                </div>
                <div class="voffset-10">
                    @if (isSummary) {
                        <app-purchase-edit-summary
                            [summary]="cartSummary.summary"
                            [purchaseSetId]="cartSummary.purchaseSetId"
                            (purchaseSummaryChanged)="loadSummary()"
                        ></app-purchase-edit-summary>
                    }
                </div>
                <div class="row voffset-20">
                    <div class="col">
                        @if (!showFinalizeButton) {
                            <button
                                bcClick
                                (clicked)="onCancel()"
                                class="btn btn-danger"
                            >
                                {{ "General.Cancel" | translate }}
                            </button>
                        }
                        @if (showFinalizeButton) {
                            <button
                                bcClick
                                (clicked)="onBack()"
                                class="btn btn-danger"
                            >
                                {{ "General.Back" | translate }}
                            </button>
                        }
                    </div>
                    @if (!showFinalizeButton) {
                        <div class="col text-right">
                            <button
                                bcClick
                                (clicked)="onNext()"
                                hznTestId="purchase-edit-next"
                                class="btn btn-primary"
                                [disabled]="!isAnyRemoved"
                            >
                                {{ "General.Next" | translate }}
                            </button>
                        </div>
                    }
                    @if (showFinalizeButton) {
                        <div class="col text-right">
                            <button
                                bcClick
                                (clicked)="onFinalize()"
                                hznTestId="purchase-edit-finalize"
                                class="btn btn-primary"
                            >
                                {{ "PurchaseEdit.finalize" | translate }}
                            </button>
                        </div>
                    }
                </div>
            }
        </div>
    }
</div>
